import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import axios from "axios";
import { HOME } from "@/constants/testIds";
import DataRecoveryBoard from "@/features/dataRecovery/DataRecoveryBoard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col items-center justify-center gap-6 p-6">
      <a
        data-testid={HOME.emergentLink}
        className="App-link"
        href="https://emergent.sh"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          alt="Emergent"
          src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4"
        />
      </a>
      <p className="mt-2 text-slate-300">ProTek Mission Board</p>
      <Link
        to="/data-recovery"
        className="px-4 py-2 rounded bg-cyan-600 hover:bg-cyan-500 text-white text-sm font-medium"
      >
        Open Data Recovery Board →
      </Link>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/data-recovery" element={<DataRecoveryBoard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
